export enum SearchFilterTypes {
    OFFER_TYPE,
    MULTI_CHECKBOX,
    SELECT_RANGE,
    RANGE,
    RADIO,
    SLIDER
}
export enum SearchFilterTypes {
    OFFER_TYPE,
    MULTI_CHECKBOX,
    SELECT_RANGE,
    RANGE,
    RADIO,
    SLIDER
}
